import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { MoodboardItem } from '../types/moodboard';
import { MoodboardCard } from './MoodboardCard';
interface MoodboardGridProps {
  items: MoodboardItem[];
  onDelete: (id: string) => void;
  highlightedItemIds?: Set<string> | null;
  onImageClick?: (id: string) => void;
}
export function MoodboardGrid({
  items,
  onDelete,
  highlightedItemIds,
  onImageClick
}: MoodboardGridProps) {
  if (items.length === 0) {
    return <div className="flex flex-col items-center justify-center py-20 sm:py-32 text-center px-4" data-id="element-278">
        <p className="font-heading font-light text-[14px] tracking-[0.25em] uppercase text-black mb-4" data-id="element-279">
          NESSUN ELEMENTO
        </p>
        <p className="text-[12px] text-[#666] max-w-md leading-[1.6] font-sans" data-id="element-280">
          Aggiungi immagini, note, link o palette colori per iniziare a
          costruire la tua board.
        </p>
      </div>;
  }
  return <div className="columns-1 sm:columns-2 lg:columns-3 xl:columns-4 gap-4 sm:gap-8 pb-16 sm:pb-24" data-id="element-281">
      <AnimatePresence mode="popLayout" data-id="element-282">
        {items.map((item, index) => {
        const isHighlighted = highlightedItemIds !== null && highlightedItemIds.has(item.id);
        const isDimmed = highlightedItemIds !== null && !highlightedItemIds.has(item.id);
        return <MoodboardCard key={item.id} item={item} onDelete={onDelete} isHighlighted={isHighlighted} isDimmed={isDimmed} onImageClick={onImageClick} index={index} data-id="element-283" />;
      })}
      </AnimatePresence>
    </div>;
}